<template>
    <div class="sessionstest">
        <Header/>

        <img :src="sessionsbannerbackup" class="sessionsbannerbackup">

        <div class="agenda">
            <h1>Agenda</h1>

            <div class="timesgrey">
                <ul>
                    <li>10 a.m. - 10:40 a.m. ET</li>
                    <div class="links">
                        <a href="https://vimeo.com/467471030">The Future of IT: Cyber threat landscape, security, backup and your transformation amidst change</a>
                    </div>
                </ul>
            </div>
            <div class="timeswhite">
                <ul>
                    <li>10:40 a.m. - 10:50 a.m. ET</li>
                    <div class="links">
                        <a href="">Experience and networking break</a>
                    </div>
                </ul>
            </div>
            <div class="timesgrey">
                <ul>
                    <li>10:50 a.m. - 11:50 a.m. ET</li>
                    <div class="links">
                        <a href="https://vimeo.com/467518249">Beating ransomware: Real stories from the front lines</a>
                        <a href="https://vimeo.com/467519120">Hybrid backup and DRaaS with VCSPs</a>
                        <a href="https://vimeo.com/467519798">Taking charge of your data in a multi-cloud world</a>
                    </div>
                </ul>
            </div>
            <div class="timeswhite">
                <ul>
                    <li>11:50 a.m. - 12:15 p.m. ET </li>
                    <div class="links">
                        <a href="https://vimeo.com/467472147">Experience and networking break</a>
                    </div>
                </ul>
            </div>
            <div class="timesgrey">
                <ul>
                    <li>12:15 p.m. - 1:15 p.m. ET </li>
                    <div class="links">
                        <a href="https://vimeo.com/467520199">Protecting Linux, Windows, UNIX and more with Veeam</a>
                        <a href="https://vimeo.com/467520874">Kubernetes data protection best practices with Kasten by Veeam</a>
                        <a href="https://vimeo.com/467521569">Safe-guarding Microsoft Office 365 data with Veeam</a>
                    </div>
                </ul>
            </div>
            <div class="timeswhite">
                <ul>
                    <li>1:15 p.m. - 1:30 p.m. ET </li>
                    <div class="links">
                        <a href="">Experience and networking break</a>
                    </div>
                </ul>
            </div>
            <div class="timesgrey">
                <ul>
                    <li>1:30 p.m. - 2:30 p.m. ET </li>
                    <div class="links">
                        <a href="https://vimeo.com/467524524">Protecting (and recovering) for Microsoft Active Directory, SQL Server and more with Veeam</a>
                        <a href="https://vimeo.com/467523959">How to get infinite cloud scale for your backups with Veeam</a>
                        <a href="https://vimeo.com/467525045">Stay ahead of data protection with Veeam's proactive monitoring and alerting</a>
                    </div>
                </ul>
            </div>
            <div class="timeswhite">
                <ul>
                    <li>2:30 p.m. - 3:20 p.m. ET</li>
                    <div class="links">
                        <a href="https://vimeo.com/467473458">Closing keynote</a>
                    </div>
                </ul>
            </div>
        </div>

    </div>
</template>





<script>
    import Header from "../components/Header.vue";
    import sessionsbannerbackup from "../assets/sessionsbannerbackup.png";


    export default {
        name: "SessionsBackup",
        components: {
            Header
        },
        data () {
            return {
                sessionsbannerbackup
            }
        }
    }

</script>






<style scoped>

    .sessionsbannerbackup {
        width: 100%
    }

    .agenda {
        height: 100%;
        width: 100%;
        border-radius: 0px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-content: center;
        align-items: center;
    }

    h1 {
        font-family: guardianfont;
        font-size: 40px;
        line-height: 48px;
        letter-spacing: 0em;
        text-align: center;
        padding: 30px;
    }

    .timesgrey, .timeswhite {
        width: 100%;
        height: 100%;
        padding: 20px;

        display: flex;
        flex-direction: row;
        justify-content: center;
        align-content: center;
        align-items: center;
    }

    .timesgrey {
        background-color: #F1F1F1;
    }

    .timesgrey ul, .timeswhite ul {
        text-align: center;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-content: center;
        align-items: center;
        margin: 20px;
        list-style: none;
        font-family: guardianfont;
    }

    .links {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-content: center;
        align-items: center;
        margin: 20px;
    }

    a {
        text-decoration: none;
        color: #00b336;
    }

</style>